import './product-card-skeleton.scss';
